var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined fill-height",
    attrs: {
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c('v-card-subtitle', [_vm._v("자재연결 목록")]), _c('v-divider')];
      },
      proxy: true
    }, _vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value,
              item = _ref.item;
          return [_c('span', {
            key: index,
            attrs: {
              "title": header.withTitle ? header.formatter.bind(item)(value, item) : undefined
            },
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    }), {
      key: "item.code",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-list-item', {
          attrs: {
            "dense": "",
            "target": "_blank",
            "href": item.href
          }
        }, [_c('v-list-item-avatar', {
          attrs: {
            "color": "content"
          }
        }, [_c('v-img', {
          attrs: {
            "src": item.photo
          },
          scopedSlots: _vm._u([{
            key: "placeholder",
            fn: function fn() {
              return [_c('v-icon', [_vm._v("mdi-chip")])];
            },
            proxy: true
          }], null, true)
        })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
          attrs: {
            "title": item.code
          }
        }, [_vm._v(" " + _vm._s(item.code) + " ")]), _c('v-list-item-subtitle', {
          attrs: {
            "title": item.vendorItemCode
          }
        }, [_vm._v(" " + _vm._s(item.vendorItemCode) + " ")])], 1)], 1)];
      }
    }, {
      key: "item.shows",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-switch', _vm._b({
          staticClass: "d-inline-block ml-1 mr-n3",
          on: {
            "change": function change(shows) {
              return _vm.update({
                _id: item._id,
                shows: shows
              });
            }
          },
          model: {
            value: item.shows,
            callback: function callback($$v) {
              _vm.$set(item, "shows", $$v);
            },
            expression: "item.shows"
          }
        }, 'v-switch', _vm.attrs_switch, false))];
      }
    }, {
      key: "item.isActive",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-switch', _vm._b({
          staticClass: "d-inline-block ml-1 mr-n3",
          on: {
            "change": function change(isActive) {
              return _vm.update({
                _id: item._id,
                isActive: isActive
              });
            }
          },
          model: {
            value: item.isActive,
            callback: function callback($$v) {
              _vm.$set(item, "isActive", $$v);
            },
            expression: "item.isActive"
          }
        }, 'v-switch', _vm.attrs_switch, false))];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('manufacturing-material-link-update-btn', _vm._b({
          attrs: {
            "small": "",
            "text": "",
            "color": "primary"
          },
          on: {
            "setLoading": function setLoading(bool) {
              return _vm.loading = bool;
            },
            "init": function init($event) {
              return _vm.$emit('init');
            }
          }
        }, 'manufacturing-material-link-update-btn', {
          loading: _vm.loading,
          material: _vm.material,
          link: item
        }, false), [_vm._v(" 정보반영 ")])];
      }
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    loading: _vm.loading
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }